import { render, staticRenderFns } from "./NotifyEdit.vue?vue&type=template&id=0a822cc9"
import script from "./NotifyEdit.vue?vue&type=script&lang=js"
export * from "./NotifyEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports